
function berechneDivisor(nk) {
  let divisor = 1;
  for (let i = 0; i < nk; i++) {
    divisor *= 10;
  }
  return divisor;
}

export function IntToBetrag(zahl,nk=2, ShowNull = false) {
  if (zahl==="") zahl=0;
  return (
    <span>
      <nobr>{IntToBetragText(zahl,nk,ShowNull)}</nobr>
    </span>
  );
}

export function IntToBetragText(zahl,nk=2, ShowNull = false) {
  // Verwende Intl.NumberFormat, um die Zahl zu formatieren
  const formatter = new Intl.NumberFormat("de-DE", {
    style: "decimal", // Stil auf 'decimal' setzen
    currency: "EUR", // Währung auf 'none' setzen
    minimumFractionDigits: nk > 0 ? nk : 0, // Mindestanzahl der Nachkommastellen
    maximumFractionDigits: nk > 0 ? nk : 0, // Maximale Anzahl der Nachkommastellen
    useGrouping: nk > 0 ,
  });
  //console.log("IntToBetragText",zahl,parseInt("0"+zahl),parseFloat("0"+zahl),parseFloat(0) );
  if (parseFloat("0"+zahl)===0 && !ShowNull)
    return "";
  return formatter.format(parseFloat("0"+zahl) / berechneDivisor(nk)); 
  
}
